import * as React from 'react'
import Main from '../Components/Main'
import Persistence from '../Components/Persistence'
import { C, T } from '@homeschooling/sdk'

import HorizontalLine from '../Components/Common/HorizonalLine'
import { Edit, Save } from '../Components/Icons'
import { InputField } from '../Components/Form/InputField'
import SDKFactory from '../Components/SDKFactory'

import * as _ from 'lodash'

Persistence.setValues()

interface Props { }

interface Form {
    [key: string]: string
  }

interface State {
    user: T.User
    tz: string
    students: T.Student[]
    editUser: boolean
    editPass: boolean
    errors: { [key: string]: string }
    form: Form
}

export class Account extends React.Component<Props, State> {

    private usersSdk = SDKFactory.getUsersSDK()

     public constructor(props: Props) {
        super(props)

        let user = Persistence.getUser() as T.User
        let tz = Persistence.getTz() as string

        this.state = {
            user: user,
            tz,
            students: Persistence.getStudents(),
            editUser: false,
            editPass: false,
            errors: { },
            form: {
                name: user.name,
                tz,
                city: user.city ? user.city : '',
                state: user.state ? user.state : '',
                password: '',
                verify_password: ''
            }
        }

    }

    public inputChanged = (key: string) =>
            (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                const { form } = this.state
                form[key] = e.target.value
    
                this.setState({
                    form,
                })
            }

   public updateTz = async (tz: string) => {
        if(tz !== Persistence.getTz()) {
            Persistence.setTz(tz)
        }
   }         

   public updateUser = async () => {
             
   let errors = this.verifyUserInfo()
   
           if(Object.keys(errors).length !== 0){
               this.setState({errors: errors})
               return
           }
   
           let form = this.state.form
          
           let data: T.User = {
            name: form.name,
            city: form.city,
            state: form.state
           } as T.User
                  
           this.updateUserViaSdk(data)
           this.updateTz(form.tz)
   }

   public verifyUserInfo = () => {
               const { form } = this.state
               let errors: any = {}
   
               if(!form.name) errors['name'] = 'Name is required'
               if(!form.city) errors['city'] = 'City is required'
               if(!form.state) errors['state'] = 'State is required'
               
               return errors
           }

    public verifyPassword = () => {

        const { form } = this.state
        let errors: any = {}

        if(!form.password) errors['password'] = 'Password is requried'
        if(!form.confirm) errors['confirm'] = 'Password confirmation is required'
        if(form.password.length < 8) errors['password'] = 'Password must be atleast 8 characters'
        if(form.password.length > 24) errors['password'] = 'Password must be less than 25 charters'
        if(form.password !== form.confirm) errors['confirm'] = 'Confirmation does not match Password'

        if(Object.keys(errors).length > 0) {
            this.setState({errors: errors})
        } else {
            this.updatePassword(form.password)
        }

    }       

    public updateUserViaSdk = async (data: T.User) => {
                try{
        
                    const res = await this.usersSdk.patchUser(this.state.user.id, data)
                    let user = res.data
        
                    const hasError: boolean = _.get(user, 'errors', false) as boolean
        
                    if(!hasError && res.status === 'success'){
                        user = user as T.User
                        
                        Persistence.setUser(user)
                        this.setState({editUser: false, user: user})
                    }
                    return {}
                } catch (reason) {
                    console.log('Error saving schedule event', reason)
                    return {}
                }
            } 
            
    public updatePassword = async (data: any) => {
                try{
      
                    const res = await this.usersSdk.updatePassword(this.state.user.id, data)
                    let user = res.data
        
                    const hasError: boolean = _.get(user, 'errors', false) as boolean
        
                    if(!hasError && res.status === 'success'){
                        user = user as T.User
                        
                        console.log('pass updated', user)
                        //this.props.inPlaceUpdate(note)
                        this.setState({form: {}, editPass: false, user: user})
                        //this.props.closeForm()
                    }
                    return {}
                } catch (reason) {
                    console.log('Error updating password', reason)
                    return {}
                }
            }         

    public editPasswosrdFIeld = () => {
        const { form } = this.state
        return (
            <div className='flex flex-cols flex-gap-2'>
                <div>        <InputField
                                                    borderColor='default'
                                                    cb={this.inputChanged('password')}
                                                    disabled={false}
                                                    errors={this.state.errors?.state}
                                                    helperErrors={true}
                                                    label={'Password'}
                                                    labelColor='default'
                                                    id='password'
                                                    required={true}
                                                    type='password'
                                                    value={form.password}
                                                    placeHolder='Password'
                                                >
                    
                                                </InputField>
                </div>
                <div>
                    <InputField
                                                    borderColor='default'
                                                    cb={this.inputChanged('verify_password')}
                                                    disabled={false}
                                                    errors={this.state.errors?.state}
                                                    helperErrors={true}
                                                    label={'Verify Password'}
                                                    labelColor='default'
                                                    id='verify_password'
                                                    required={true}
                                                    type='password'
                                                    value={form.verify_password}
                                                    placeHolder='Verify Password'
                                                >
                                                </InputField>            
                </div>
                <div>
                    <button
                                        onClick={() => console.log('update password')} 
                                        type="button" 
                                        className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                            Update 
                                        </button>
                                    </div>
                </div>    
        )
    }     

    public editAccountInfo = () => {
        let iconClass = 'cursor-pointer fill-slate-500 hover:fill-black mx-1'
        const { form } = this.state

        return (
                       <div className="bg-white overflow-hidden w-full lg:w-[50%] shadow rounded-lg border">
    <div className="px-12 flex flex-row py-10 sm:px-6">

        <div className="grow text-lg leading-6 font-medium text-gray-900">
            User Profile
        </div>
        <div className='flex hover:cursor-pointer'
                                        onClick={() => this.updateUser()}
                                        >
                                        <Save
                                            className={iconClass}
                                            size='medium' />
                                    </div>
    </div>
    <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
            <div className="py-1 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <InputField
                                                    borderColor='default'
                                                    cb={this.inputChanged('name')}
                                                    disabled={false}
                                                    errors={this.state.errors?.name}
                                                    helperErrors={true}
                                                    label={'Full Name'}
                                                    labelColor='default'
                                                    id='event_name'
                                                    required={true}
                                                    type='text'
                                                    value={form.name}
                                                    placeHolder='Add Event Name'
                                                >
                    
                                                </InputField>
                                            
                </dd>
            </div>
            <div className="py-1 grid grid-rows-3 gap--1 sm:py-5 sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    Email address
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {this.state.user.email}
                </dd>
            </div>
            <div className="py-1 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <InputField
                                                            borderColor='default'
                                                            cb={this.inputChanged('state')}
                                                            disabled={false}
                                                            errors={this.state.errors?.state}
                                                            helperErrors={true}
                                                            label={'State'}
                                                            labelColor='default'
                                                            id='startTime'
                                                            required={true}
                                                            options={C.getStatesByCountry('US')}
                                                            type='select'
                                                            value={form.state}
                                                            placeHolder='Select State'
                                                        >
                                                        </InputField>
                </dd>
            </div>
            <div className="py-1 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dd className="mt-1 text-sm sm:mt-0 sm:col-span-2">
                    <InputField
                                                    borderColor='default'
                                                    cb={this.inputChanged('city')}
                                                    disabled={this.state.form.state.length < 2}
                                                    errors={this.state.errors?.city}
                                                    helperErrors={true}
                                                    label={'City'}
                                                    labelColor='default'
                                                    id='city'
                                                    required={true}
                                                    type='autocomplete'
                                                    value={form.city}
                                                    placeHolder='City'
                                                    options={C.getCitiesByState(this.state.form.state)}
                                                >
                    
                                                </InputField>
                </dd>
            </div>
            <div className="py-1 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    
                                                        <InputField
                                                            borderColor='default'
                                                            cb={this.inputChanged('tz')}
                                                            disabled={false}
                                                            errors={this.state.errors?.tz}
                                                            helperErrors={true}
                                                            label={'Timezone'}
                                                            labelColor='default'
                                                            id='startTime'
                                                            required={true}
                                                            options={C.getTzOptions()}
                                                            type='select'
                                                            value={form.tz}
                                                            placeHolder='Select Timezone'
                                                        >
                                                        </InputField>
                        
                </dd>
            </div>
        </dl>
    </div>
    </div> 
        )
    }

    public getAccountIno = () => {


        let iconClass = 'cursor-pointer fill-slate-500 hover:fill-black mx-1'

        return (
                       <div className="bg-white overflow-hidden w-full lg:w-[50%] shadow rounded-lg border">
    <div className="px-12 flex flex-row py-10 sm:px-6">

        <div className="grow text-lg leading-6 font-medium text-gray-900">
            User Profile
        </div>
        <div className='flex hover:cursor-pointer'
                                        onClick={() => this.setState({editUser: true})}
                                        >
                                        <Edit
                                            className={iconClass}
                                            size='medium' />
                                    </div>
    </div>
    <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    Full Name
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {this.state.user.name}
                </dd>
            </div>
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    Email address
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {this.state.user.email}
                </dd>
            </div>
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    City
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {this.state.user.city}
                </dd>
            </div>
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    State
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {this.state.user.state}
                </dd>
            </div>
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    Timezone
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {this.state.tz}
                </dd>
            </div>
        </dl>
    </div>
</div> 
        )
    }

    public updatePasswordFrom = () => {
        if(!this.state.editPass){
            return (
            <div className="flex justify-center w-full">
                <div className='flex p-5'>
                   <button type="button" onClick={() => this.setState({editPass: true})}className="px-4 rounded-lg py-2 text-lg font-medium bg-white border border-gray-700 text-gray-800 hover:text-gray-900 hover:bg-gray-300">
                                     Update Password
                                </button>
                </div>
            </div>
            )
        } else {
            return (
                <div className='flex flex-col gap-2 w-full'>
                    <div className='text-lg leading-6 font-medium text-gray-900'>Edit Password</div>
                    <div>
                                              <InputField
                                                borderColor='default'
                                                cb={this.inputChanged('password')}
                                                disabled={false}
                                                errors={this.state.errors.password ? true : false}
                                                helperErrors={true}
                                                label={'Password'}
                                                labelColor='default'
                                                id='password'
                                                required={true}
                                                type='password'
                                                value={this.state.form.password}
                                              >
                    
                                              </InputField>
                                              </div>
                                              <div>
                                              <InputField
                                                borderColor='default'
                                                cb={this.inputChanged('confirm')}
                                                disabled={false}
                                                errors={this.state.errors.confirm ? true : false}
                                                helperErrors={true}
                                                label={'Confirm Password'}
                                                labelColor='default'
                                                id='confirm'
                                                required={true}
                                                type='password'
                                                value={this.state.form.confirm}
                                              >
                    
                                              </InputField>
                                              </div>
                    <div className='flex flex-row py-5'>
                        <div className='flex w-full justify-end'>
                        <button type="button" onClick={() => this.setState({editPass: false})} className="px-4 rounded-lg py-2 mr-2 text-md font-medium bg-white border border-gray-700 text-gray-800 hover:text-gray-900 hover:bg-gray-300">
                                     Cancel
                                </button>
                        <button type="button" onClick={() => this.verifyPassword()} className="px-4 rounded-lg py-2 text-md font-medium bg-white border border-gray-700 text-gray-800 hover:text-gray-900 hover:bg-gray-300">
                                     Save
                                </button>
                        </div>
                   
                </div>

                </div>
            )
        }
        
    }

    public render () {

        let display = this.getAccountIno()

        if(this.state.editUser) display = this.editAccountInfo()

        return (
            <Main>
                <div className='m-10'>
    <div>
        {display}
    </div>
    <div>
        <div className='flex py-10 w-[50%]'>
        {this.updatePasswordFrom()}
        </div>
    </div>
    <div className='py-8'>
                                <HorizontalLine
                                    color='#999999'
                                    size='1px'
                                    padding='3.5em' />
                            </div>
</div>
            </Main>
        )
    }
}

export default Account